import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=58b7f2c8&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=58b7f2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7f2c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b7f2c8')) {
      api.createRecord('58b7f2c8', component.options)
    } else {
      api.reload('58b7f2c8', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=58b7f2c8&scoped=true&", function () {
      api.rerender('58b7f2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/EmptyState.vue"
export default component.exports